/* MORN theme behaviour: buy box, How to Morn steps, gallery and the jelly/scroll motion. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // restartable squash-and-stretch
  const wob = (el) => {
    if (!el || reduce) return;
    el.classList.remove('wob');
    void el.offsetWidth;
    el.classList.add('wob');
    el.addEventListener('animationend', () => el.classList.remove('wob'), { once: true });
  };
  window.mornWob = wob;

  // ---------- buy box ----------
  function initBuyBox(root) {
    const dataEl = $('script[data-morn-product]', root);
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const L = root.dataset;
    const money = (cents) =>
      new Intl.NumberFormat('de-CH', { style: 'currency', currency: data.currency || 'CHF' }).format(cents / 100);
    const sticksPerBox = +L.sticksPerBox || 21;
    const mlPerBox = +L.mlPerBox || 168;
    const boxes = (v) => parseInt(v.title, 10) || 1;
    const base = data.variants[0] ? data.variants[0].price / boxes(data.variants[0]) : 0;
    const hasPlans = data.plans.length > 0;
    const preorder = L.preorder === 'true';
    const labelOnce = preorder ? L.labelPreorder : L.labelAdd;
    const state = {
      variant: (data.variants.find((v) => v.available) || data.variants[0] || {}).id,
      plan: hasPlans ? 'sub' : 'once',
    };
    const variantById = (id) => data.variants.find((v) => v.id === id);
    const planId = () => (state.plan === 'sub' && hasPlans ? data.plans[0].id : null);
    const priceFor = (v, plan) => (plan === 'sub' && hasPlans && v.plans[data.plans[0].id] != null ? v.plans[data.plans[0].id] : v.price);
    const listFor = (v) => Math.round(base * boxes(v));
    const pct = (now, was) => Math.round((1 - now / was) * 100);

    function render() {
      const v = variantById(state.variant);
      if (!v) return;
      $$('[data-variant-id]', root).forEach((card) => {
        const cv = variantById(+card.dataset.variantId);
        const now = priceFor(cv, state.plan);
        const off = pct(now, listFor(cv));
        card.setAttribute('aria-pressed', cv.id === state.variant);
        $('.p', card).textContent = money(now);
        const save = $('.save', card);
        save.textContent = off > 0 ? `−${off} %` : '';
        save.hidden = off <= 0;
      });
      $$('[data-plan]', root).forEach((p) => {
        const now = priceFor(v, p.dataset.plan);
        const was = listFor(v);
        p.setAttribute('aria-pressed', p.dataset.plan === state.plan);
        $('.pp-now', p).textContent = money(now);
        const del = $('del', p);
        del.textContent = pct(now, was) > 0 ? money(was) : '';
        const extra = $('[data-plan-extra]', p);
        if (extra) {
          const off = pct(v.plans[data.plans[0].id] ?? v.price, v.price);
          extra.textContent = off > 0 ? `−${off} % extra` : '';
          extra.hidden = off <= 0;
        }
      });
      const now = priceFor(v, state.plan);
      const n = boxes(v);
      $$('[data-cta]', root).forEach((b) => {
        b.querySelector('span').textContent = `${state.plan === 'sub' ? L.labelSub : labelOnce} · ${money(now)}`;
        b.disabled = !v.available;
      });
      const unit = $('[data-unit]', root);
      if (unit)
        unit.textContent = `${money(now / (sticksPerBox * n))} ${L.labelPerStick} · ${money(now / ((mlPerBox * n) / 100))} / 100 ml${L.labelVat ? ' · ' + L.labelVat : ''}`;
      const sticky = $('[data-sticky-name]', root);
      if (sticky) sticky.textContent = v.title === 'Default Title' ? data.title : `${data.title} · ${v.title}`;
      const sp = $('[data-sticky-price]', root);
      if (sp) sp.textContent = money(now);
    }

    $$('[data-variant-id]', root).forEach((card) =>
      card.addEventListener('click', () => {
        state.variant = +card.dataset.variantId;
        render();
        wob(card);
      })
    );
    $$('[data-plan]', root).forEach((p) =>
      p.addEventListener('click', () => {
        state.plan = p.dataset.plan;
        render();
        wob(p);
      })
    );

    async function add(btn) {
      wob(btn);
      const err = $('[data-error]', root);
      if (err) err.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      const item = { id: state.variant, quantity: 1 };
      if (planId()) item.selling_plan = planId();
      // shows up in cart, checkout, order confirmation and the order in the admin
      if (preorder && L.preorderKey) item.properties = { [L.preorderKey]: L.preorderValue };
      const drawer = document.querySelector('cart-drawer');
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'error');
        if (drawer && typeof drawer.renderContents === 'function' && json.sections) {
          drawer.classList.remove('is-empty');
          const first = (json.items && json.items[0]) || json;
          drawer.renderContents({ ...json, id: first.id });
        } else {
          location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        if (err) {
          err.textContent = L.labelError || e.message;
          err.hidden = false;
        }
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }
    $$('[data-cta]', root).forEach((b) => b.addEventListener('click', () => add(b)));

    // gallery thumbs
    const stage = $('.stage img', root);
    $$('[data-thumb]', root).forEach((t) =>
      t.addEventListener('click', () => {
        if (t.dataset.thumb === '#label') {
          const lbl = document.getElementById('label');
          if (lbl) lbl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        stage.src = t.dataset.thumb;
        stage.removeAttribute('srcset');
        stage.alt = t.dataset.alt || '';
        $$('[data-thumb]', root).forEach((x) => x.setAttribute('aria-pressed', x === t));
      })
    );

    // shipping cutoff note: weekdays before 14:00
    const ship = $('[data-ship]', root);
    if (ship) {
      const d = new Date();
      ship.textContent = d.getDay() >= 1 && d.getDay() <= 5 && d.getHours() < 14 ? L.labelShipToday : L.labelShipNext;
    }

    // sticky add-to-cart once the main button scrolls away
    const sticky = $('.sticky', root);
    const main = $('[data-cta-main]', root);
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', !show);
        $$('button', sticky).forEach((b) => (b.tabIndex = show ? 0 : -1));
      }).observe(main);
    }
    render();
  }

  // ---------- How to Morn: one photo per step ----------
  function initHow(sec) {
    const steps = $$('[data-step]', sec);
    const shots = $$('.how-photo img', sec);
    shots.forEach((im, k) => im.classList.toggle('on', k === 0));
    const list = $('.steps', sec);
    if (!steps.length) return;
    let cur = 0;
    let timer = null;
    const set = (i) => {
      cur = i;
      steps.forEach((li, k) => {
        li.classList.toggle('active', k === i);
        k === i ? li.setAttribute('aria-current', 'step') : li.removeAttribute('aria-current');
      });
      shots.forEach((im, k) => im.classList.toggle('on', k === i));
      wob($('.n', steps[i]));
    };
    const stop = () => {
      clearInterval(timer);
      list.classList.remove('auto');
    };
    steps.forEach((li, i) => {
      li.addEventListener('mouseenter', () => { stop(); set(i); });
      li.addEventListener('click', () => { stop(); set(i); });
      li.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stop(); set(i); }
      });
    });
    if (!reduce && 'IntersectionObserver' in window && shots.length > 1) {
      new IntersectionObserver(([en], obs) => {
        if (!en.isIntersecting) return;
        obs.disconnect();
        list.classList.add('auto');
        const restart = () => { const a = steps[cur]; a.classList.remove('active'); void a.offsetWidth; a.classList.add('active'); };
        restart();
        timer = setInterval(() => { set((cur + 1) % steps.length); restart(); }, 4500);
      }, { threshold: 0.4 }).observe(sec);
    }
  }

  // ---------- motion ----------
  function initMotion() {
    if (reduce) return;
    document.documentElement.classList.add('anim');

    // hero headline: words drop in softly
    $$('.morn.hero h1').forEach((h1) => {
      let i = 0;
      [...h1.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) return frag.appendChild(document.createTextNode(part));
            const sp = document.createElement('span');
            sp.className = 'w';
            sp.style.setProperty('--i', i++);
            sp.textContent = part;
            frag.appendChild(sp);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) {
          n.classList.add('w');
          n.style.setProperty('--i', i++);
        }
      });
    });

    $$('.morn .route .draw').forEach((d) => d.style.setProperty('--len', Math.ceil(d.getTotalLength())));

    // reveal: content stays visible and only slides into place
    const targets = $$('.morn .head, .morn .chapter, .morn .steps li, .morn .ing, .morn .label, .morn .cmp-wrap, .morn .faq details, .morn .how-photo, .morn .band-card, .morn .what-card, .morn .principle, .morn .why-ben, .morn .why-mid, .morn .route');
    targets.forEach((el) => el.classList.add('rv'));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      }), { rootMargin: '0px 0px -8% 0px' });
      targets.forEach((el) => (el.getBoundingClientRect().top < innerHeight ? el.classList.add('in') : io.observe(el)));

      // count-up for the fact band
      const cio = new IntersectionObserver((es) => es.forEach((en) => {
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        const el = en.target;
        const final = el.textContent;
        const m = final.match(/^([\d'’.,]+)(.*)$/);
        if (!m) return;
        const to = parseInt(m[1].replace(/\D/g, ''), 10);
        const unit = m[2];
        const t0 = performance.now();
        const step = (now) => {
          const p = Math.min(1, (now - t0) / 1200);
          el.textContent = p < 1 ? Math.round(to * (1 - Math.pow(1 - p, 3))).toLocaleString('de-CH') + unit : final;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }), { threshold: 0.6 });
      $$('.morn [data-count]').forEach((el) => cio.observe(el));
    }

    // scroll-linked: hero parallax, band zoom, marquee skew
    const heroImg = $('.morn .hero-photo img');
    const bands = $$('.morn.ritual-band, .morn .ritual-band');
    const tracks = $$('.morn .big-track');
    let lastY = scrollY;
    let skew = 0;
    let ticking = false;
    const onScroll = () => {
      const y = scrollY;
      if (heroImg) heroImg.style.transform = `scale(1.08) translateY(${Math.min(60, y * 0.06)}px)`;
      bands.forEach((band) => {
        const img = $('img', band);
        if (!img) return;
        const r = band.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, (innerHeight - r.top) / (innerHeight + r.height)));
        img.style.setProperty('--zoom', (1.22 - p * 0.2).toFixed(3));
      });
      skew = Math.max(-10, Math.min(10, (y - lastY) * -0.35));
      tracks.forEach((t) => t.style.setProperty('--skew', skew + 'deg'));
      lastY = y;
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    setInterval(() => {
      if (Math.abs(skew) > 0.1) { skew *= 0.5; tracks.forEach((t) => t.style.setProperty('--skew', skew + 'deg')); }
    }, 120);
    onScroll();
  }

  // ---------- "also available in English" for English-speaking browsers on the German site ----------
  function initLangbar() {
    const bar = $('[data-morn-langbar]');
    if (!bar) return;
    const close = $('[data-langbar-close]', bar);
    const go = $('[data-langbar-go]', bar);
    const alt = $('link[rel="alternate"][hreflang="en"]');
    const first = (navigator.languages && navigator.languages[0]) || navigator.language || '';
    let dismissed = false;
    try { dismissed = localStorage.getItem('morn-langbar') === '1'; } catch (e) {}
    if (alt) go.href = alt.href;
    if (!dismissed && /^en\b/i.test(first)) bar.hidden = false;
    close.addEventListener('click', () => {
      bar.hidden = true;
      try { localStorage.setItem('morn-langbar', '1'); } catch (e) {}
    });
  }

  function init() {
    initLangbar();
    $$('[data-morn-buybox]').forEach(initBuyBox);
    $$('[data-morn-how]').forEach(initHow);
    $$('.morn .m-lang button').forEach((b) => b.addEventListener('click', () => wob(b)));
    initMotion();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  // re-run when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-morn-buybox]', e.target).forEach(initBuyBox);
    $$('[data-morn-how]', e.target).forEach(initHow);
  });
})();
